import { DrawableObject } from "./DrawableObject";
import { WorldObjectType } from "../../api";
import { Box3, Line, Mesh, Sphere, Vector3 } from "three";
import { LabelCollection } from "../../private/objects/labelCollection";
export class KmlObject extends DrawableObject {
    constructor(object, objectId) {
        super(object);
        this._opacity = 1;
        this.object = object;
        this.id = objectId;
    }
    get opacity() {
        return this._opacity;
    }
    set opacity(v) {
        this._opacity = v;
        if (this._opacity < 1) {
            this.object.traverse((o) => {
                if (o instanceof Mesh || o instanceof Line) {
                    const material = o.material;
                    material.opacity = v;
                    material.transparent = true;
                    material.depthWrite = false;
                    material.needsUpdate = true;
                }
                if (o instanceof LabelCollection) {
                    o.opacity = v;
                }
            });
        }
        else {
            this.object.traverse((o) => {
                if (o instanceof Mesh || o instanceof Line) {
                    const material = o.material;
                    material.opacity = 1;
                    material.transparent = false;
                    material.depthWrite = true;
                    material.needsUpdate = true;
                }
                if (o instanceof LabelCollection) {
                    o.opacity = 1;
                }
            });
        }
    }
    get isTransparent() {
        return this._opacity < 1;
    }
    setClippingPlanes(planes) {
        this.object.traverse((v) => {
            if (v instanceof Mesh || v instanceof Line) {
                if (Array.isArray(v.material)) {
                    for (const mat of v.material) {
                        mat.clippingPlanes = planes;
                        mat.needsUpdate = true;
                    }
                }
                else {
                    v.material.clippingPlanes = planes;
                    v.material.needsUpdate = true;
                }
            }
        });
    }
    invalidateMaterials() {
        this.object.traverse((v) => {
            if (v instanceof Mesh) {
                if (Array.isArray(v.material)) {
                    for (const mat of v.material) {
                        mat.needsUpdate = true;
                    }
                }
                else {
                    v.material.needsUpdate = true;
                }
            }
        });
    }
    getBoundingVolume() {
        const box = new Box3().setFromObject(this.object);
        const sphere = box.getBoundingSphere(new Sphere(box.getCenter(new Vector3())));
        return [sphere.center.x, sphere.center.y, sphere.center.z, sphere.radius];
    }
    getEstimatedCenter(center) {
        const box = this.getBoundingVolume();
        if (center !== undefined) {
            center.x = box[0];
            center.y = box[1];
            center.z = box[2];
            return center;
        }
        else {
            return {
                x: box[0],
                y: box[1],
                z: box[2],
            };
        }
    }
    asBlendableObject() {
        return this;
    }
    getObjectType() {
        return WorldObjectType.KmlObject;
    }
}
